import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import forms from 'constants/forms';
import Input from 'components/atoms/input';

const Thresholds = ({ errors, idPrefix }) => {
  const threshold = { ...forms.adminPanelsClinic.clinicThreshold };

  return (
    <div className="admin-patient-form-block">
      <span>Patient Thresholds</span>
      <Row>
        <Col>
          <div className="admin-patient-form-block">
            <span>Systolic</span>
            <Row>
              {threshold.systolic.map((field) => (
                <Col lg="6" md="6" sm="6" xs="12" key={field.id}>
                  <Input
                    {...field}
                    id={`${idPrefix}${field.id}`}
                    disabled={false}
                  />
                  {errors && errors[field.id] ? (
                    <div className="input-error">{errors[field.id]}</div>
                  ) : null}
                </Col>
              ))}
            </Row>
          </div>
        </Col>
        <Col>
          <div className="admin-patient-form-block">
            <span>Diastolic</span>
            <Row>
              {threshold.diastolic.map((field) => (
                <Col lg="6" md="6" sm="6" xs="12" key={field.id}>
                  <Input
                    {...field}
                    id={`${idPrefix}${field.id}`}
                    disabled={false}
                  />
                  {errors && errors[field.id] ? (
                    <div className="input-error">{errors[field.id]}</div>
                  ) : null}
                </Col>
              ))}
            </Row>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="admin-patient-form-block">
            <span>Pulse</span>
            <Row>
              {threshold.pulse.map((field) => (
                <Col lg="6" md="6" sm="6" xs="12" key={field.id}>
                  <Input
                    {...field}
                    id={`${idPrefix}${field.id}`}
                    disabled={false}
                  />
                  {errors && errors[field.id] ? (
                    <div className="input-error">{errors[field.id]}</div>
                  ) : null}
                </Col>
              ))}
            </Row>
          </div>
        </Col>
        <Col>
          <div className="admin-patient-form-block">
            <span>Resting Pulse</span>
            <Row>
              {threshold.sleepPulse.map((field) => (
                <Col lg="6" md="6" sm="6" xs="12" key={field.id}>
                  <Input
                    {...field}
                    id={`${idPrefix}${field.id}`}
                    disabled={false}
                  />
                  {errors && errors[field.id] ? (
                    <div className="input-error">{errors[field.id]}</div>
                  ) : null}
                </Col>
              ))}
            </Row>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="admin-patient-form-block">
            <span>Glucose</span>
            <Row>
              {threshold.glucose.map((field) => (
                <Col lg="6" md="6" sm="6" xs="12" key={field.id}>
                  <Input
                    {...field}
                    id={`${idPrefix}${field.id}`}
                    disabled={false}
                  />
                  {errors && errors[field.id] ? (
                    <div className="input-error">{errors[field.id]}</div>
                  ) : null}
                </Col>
              ))}
            </Row>
          </div>
        </Col>
        <Col>
          <div className="admin-patient-form-block">
            <span>Weight</span>
            <Row>
              {threshold.weight.map((field) => (
                <Col lg="6" md="6" sm="6" xs="12" key={field.id}>
                  <Input
                    {...field}
                    id={`${idPrefix}${field.id}`}
                    disabled={false}
                  />
                  {errors && errors[field.id] ? (
                    <div className="input-error">{errors[field.id]}</div>
                  ) : null}
                </Col>
              ))}
            </Row>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="admin-patient-form-block">
            <span>PEF</span>
            <Row>
              {threshold.pef.map((field) => (
                <Col lg="6" md="6" sm="6" xs="12" key={field.id}>
                  <Input
                    {...field}
                    id={`${idPrefix}${field.id}`}
                    disabled={false}
                  />
                  {errors && errors[field.id] ? (
                    <div className="input-error">{errors[field.id]}</div>
                  ) : null}
                </Col>
              ))}
            </Row>
          </div>
        </Col>
        <Col>
          <div className="admin-patient-form-block">
            <span>FEV1</span>
            <Row>
              {threshold.fev1.map((field) => (
                <Col lg="6" md="6" sm="6" xs="12" key={field.id}>
                  <Input
                    {...field}
                    id={`${idPrefix}${field.id}`}
                    disabled={false}
                  />
                  {errors && errors[field.id] ? (
                    <div className="input-error">{errors[field.id]}</div>
                  ) : null}
                </Col>
              ))}
            </Row>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="admin-patient-form-block">
            <span>Sp02</span>
            <Row>
              {threshold.sp02.map((field) => (
                <Col lg="6" md="6" sm="6" xs="12" key={field.id}>
                  <Input
                    {...field}
                    id={`${idPrefix}${field.id}`}
                    disabled={false}
                  />
                  {errors && errors[field.id] ? (
                    <div className="input-error">{errors[field.id]}</div>
                  ) : null}
                </Col>
              ))}
            </Row>
          </div>
        </Col>
        <Col />
      </Row>
    </div>
  );
};

Thresholds.propTypes = {
  idPrefix: PropTypes.string,
  errors: PropTypes.shape({}),
};
Thresholds.defaultProps = {
  idPrefix: '',
  errors: undefined,
};

export default Thresholds;
